function initSliders() {
	// HERO
	var $heroSlider = $('#hero_slider');
	if ($heroSlider.length) {

		var $slideCurrent = $('.hero-slider__info .current');
		var $slideTotal = $('.hero-slider__info .total');


		$slideCurrent.text(1);
		$slideTotal.text($heroSlider.find('.hero-slide').length);

		$heroSlider.on('init', function () {
			$('#hero_slider [data-slick-index="0"] .hero-slide').addClass('my-current-slide');

			/* enter */
			anime.timeline().add({
				targets: '.hero-slide__line1',
				translateX: [100, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1400,
				delay: 450
			});

			anime.timeline().add({
				targets: '.hero-slide__line2',
				translateX: [-100, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1400,
				delay: 600
			});

			anime.timeline().add({
				targets: '.hero-slide__btn',
				translateY: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1400,
				delay: 750
			});

			if ($heroSlider.hasClass('hero-slider--multiple')) {
				/* out */
				anime.timeline().add({
					targets: '.hero-slide__line1',
					translateX: [0, -60],
					opacity: [1, 0],
					easing: "easeInExpo",
					duration: 1400,
					delay: 1300
				});

				anime.timeline().add({
					targets: '.hero-slide__line2',
					translateX: [0, 60],
					opacity: [1, 0],
					easing: "easeInExpo",
					duration: 1400,
					delay: 1150
				});

				anime.timeline().add({
					targets: '.hero-slide__btn',
					translateY: [0, 40],
					opacity: [1, 0],
					easing: "easeInExpo",
					duration: 1400,
					delay: 900
				});
			}

		}).slick({
			autoplay: true,
			autoplaySpeed: 4000,
			lazy: 'progressive',
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			fade: true,
			speed: 600,
			easing: 'swing',
			pauseOnFocus: false,
			pauseOnHover: false
		});
	}


	$heroSlider.on('beforeChange', function (event, slick, currentSlide) {
		$("[data-slick-index='" + currentSlide + "'] .hero-slide").removeClass('my-current-slide');

		anime.timeline()
			.add({
				targets: '.hero-slide__line1',
				translateX: [60, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1400,
				delay: 250
			})
			.add({
				targets: '.hero-slide__line1',
				translateX: [0, -60],
				translateZ: 0,
				opacity: [1, 0],
				easing: "easeInExpo",
				duration: 1400,
				delay: 1300
			});

		anime.timeline()
			.add({
				targets: '.hero-slide__line2',
				translateX: [-60, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1400,
				delay: 400
			})
			.add({
				targets: '.hero-slide__line2',
				translateX: [0, 60],
				translateZ: 0,
				opacity: [1, 0],
				easing: "easeInExpo",
				duration: 1400,
				delay: 1150
			});

		anime.timeline()
			.add({
				targets: '.hero-slide__btn',
				translateY: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 1400,
				delay: 550
			})
			.add({
				targets: '.hero-slide__btn',
				translateY: [0, 40],
				translateZ: 0,
				opacity: [1, 0],
				easing: "easeInExpo",
				duration: 1400,
				delay: 1000
			});

	});

	$heroSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = (currentSlide ? currentSlide : 0) + 1;
		$slideCurrent.text(i);
		$slideTotal.text(slick.slideCount);

		//$('#hero_slider .hero-slide').removeClass('my-current-slide');
		$("[data-slick-index='" + currentSlide + "'] .hero-slide").addClass('my-current-slide');
	});

	// BLOG
	var $blog = $('.blog__slider');
	if ($blog.length) {
		$blog.imagesLoaded(function () {
			$blog.slick({
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				dots: false,
				fade: false,
				speed: 300,
				easing: 'swing',
				adaptiveHeight: false,
			});
		});
	}

	$('.nav__blog-slider .next').on('click', function (e) {
		e.preventDefault();
		$blog.slick('slickNext');
	});

	$('.nav__blog-slider .prev').on('click', function (e) {
		e.preventDefault();
		$blog.slick('slickPrev');
	});

	// Contact cards
	var $cards = $('.slider_contact_cards');

	if ($cards.length) {
		$cards.imagesLoaded(function () {

			$cards.slick({
				autoplay: true,
				autoplaySpeed: 4000,
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: true,
				arrows: false,
				swipe: true,
				dots: false,
				fade: false,
				pauseOnHover: true,
				speed: 700,
				easing: 'swing',
				adaptiveHeight: false,
				responsive: [
					{
						breakpoint: 1800,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 660,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});
		});

		$cards.on('init', function () {
			matchHeightReset();
		});

		$cards.on('reInit', function () {
			matchHeightReset();
		});
	}

	$('.contact-cards .next').on('click', function (e) {
		e.preventDefault();
		$cards.slick('slickNext');
	});

	$('.contact-cards .prev').on('click', function (e) {
		e.preventDefault();
		$cards.slick('slickPrev');
	});


	// MODULE SLIDER
	var $images = $('.slider-mod-image');
	var $text = $('.slider-mod-text');

	if ($images.length) {
		$images.imagesLoaded(function () {
			$images.slick({
				autoplay: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				dots: false,
				fade: true,
				speed: 300,
				easing: 'swing',
				asNavFor: $text,
				adaptiveHeight: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							fade: false,
						}
					}
				]
			});
		});
	}

	if ($text.length) {
		$text.slick({
			autoplay: false,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			fade: false,
			speed: 300,
			easing: 'swing',
			asNavFor: $images,
			adaptiveHeight: false
		});
	}

	$('.slider-mod-nav .next').on('click', function (e) {
		e.preventDefault();
		$text.slick('slickNext');
	});

	$('.slider-mod-nav .prev').on('click', function (e) {
		e.preventDefault();
		$text.slick('slickPrev');
	});


	// TESTIMONY
	var $testimony = $('.slider-testimony');

	if ($testimony.length) {
		$testimony.slick({
			autoplay: true,
			autoplaySpeed: 4000,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			fade: false,
			speed: 600,
			draggable: false,
			swipe: false,
			easing: 'swing',
			vertical: true
		});
	}

	const experiencesSlider = $(".slider-experiences");
	if (experiencesSlider.length) {
		experiencesSlider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			fade: false,
			speed: 300,
			easing: 'swing',
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}


	// Bloc trombinoscope
	let sliders = document.querySelectorAll('.slider-grab .swiper');

	sliders.forEach((slider) => {
		console.log(slider);
		const prev = slider.querySelector('.prev');
		const next = slider.querySelector('.next');

		const myswiper = new Swiper(slider, {
			loop: false,
			slidesPerView: "auto",
			spaceBetween: 20,
			speed: 700,
			autoHeight: false,
			pagination: {
				el: slider.querySelector('.slider-cards-pagination'),
				type: 'bullets',
				clickable: true,
				dynamicBullets: false,
			},
			navigation: {
				nextEl: next,
				prevEl: prev,
			},
			touchEventsTarget: "container",
			mousewheel: {
				enabled: true,
				releaseOnEdges: true,
				forceToAxis: true,
			},
			on: {
				lock: () => {
					slider.classList.remove("swiper-is-active");
				},
				unlock: () => {
					slider.classList.add("swiper-is-active");
				}
			}
		});
	});

}
